<template>
  <div class="img-scroll" v-infinite-scroll="loadPhotos" v-loading="loading">
    <image-list :list="imgList" ref="imageList" :readOnly="true" />
  </div>
</template>

<script>
import { Ajax } from '@/common'
import { readState } from '@/common/nav-state'
import imageList from '@/views/moments/modules/imageList.vue'
export default {
  name: 'MomentsView',
  components: {
    imageList
  },
  data() {
    return {
      imgList: [],
      loading: false,
      pageNum: 1,
      pages: 0
    }
  },
  computed: {
    studentId() {
      const s = readState(this.$route, ['id', 'type'])
      return s ? s.id : ''
    }
  },
  watch: {
    '$route.query.id'() {
      // 同组件复用（A→B 后退）时重新读参取数
      this.pageNum = 1
      if (this.fetchList) this.fetchList(false)
    }
  },
  created() {
    if (!readState(this.$route, ['id', 'type'])) {
      if (this.$message) this.$message.error('Missing student')
      this.$router.replace('/students')
      return
    }
    this.fetchList(false)
  },
  methods: {
    loadPhotos() {
      if (this.pageNum < this.pages && !this.loading) {
        this.fetchList(true)
      }
    },
    async fetchList(s) {
      this.pageNum = s ? this.pageNum + 1 : this.pageNum
      this.loading = true
      var res = await Ajax.post('/moments/media/getMediaListV1', {
        studentId: this.studentId,
        pageNum: this.pageNum,
        status: 2,
        // date: moment(this.date).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
        size: 42
      })
      this.loading = false
      if (res.code == '0000') {
        if (this.pageNum == 1) {
          this.imgList = res.data.records
        } else {
          this.imgList = [...this.imgList, ...res.data.records]
        }
        this.imgList = this.imgList.filter(
          (item, index, self) => index === self.findIndex((t) => t.id === item.id)
        )
        this.pages = res.data.pages
      }
    }
  }
}
</script>
<style lang="less" scoped>
.img-scroll {
  /deep/.el-loading-mask {
    position: fixed;
    background-color: rgba(255, 255, 255, 0.2);
  }
}
</style>
